import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/beos/error.tsx");
